import { defineStore } from "pinia";

export const useMainAppStore = defineStore("mainApp", {
  // 定义状态
  state: () => ({
    token: "",
  }),

  // 定义派生状态
  getters: {
    // doubleCount: (state) => state.count * 2
  },

  // 定义修改状态的方法
  actions: {
    setToken(token) {
      this.token = token;
    },
  },
});
